import Vue from 'vue'
export const Events = new Vue()



// WEBPACK FOOTER //
// ./src/events.js